import React from "react";
import { Column, Notification } from "@dls/web";

const InlineErrorMessage = ({ message, fullWidth = false }) => {
  return (
    <Column xs={12} md={fullWidth ? 12 : 6}>
      <Notification type="alert" content={message} />
    </Column>
  );
};

export default InlineErrorMessage;
